export default __webpack_public_path__ + "static/cashflow_101_1993_main-69909ec2aa3f0b603ca07f39fe1dcfb1.jpeg";